const RESOURCE_NAME = '/ext-services';

export default axios => ({
    find(userId, params) {//expand=settings
        return axios.get(`/user/${userId}${RESOURCE_NAME}`, {params});
    },
    getServiceFormControls(userId, params) {//expand=settings
        return axios.get(`/user/${userId}${RESOURCE_NAME}/form-controls`, {params});
    },
    getServiceData(userId, service, params) {//expand=settings
        return axios.get(`/user/${userId}${RESOURCE_NAME}/${service}`, {params});
    },
    update(userId, data, params) {
        return axios.put(`/user/${userId}${RESOURCE_NAME}`, data, {params});
    },
    callServiceMethod(userId, service, method, data, params) {
        let url = `${RESOURCE_NAME}/${service}/${method}`
        if (userId > '') url = `/user/${userId}`+url
        return axios.post(url, data, {params});
    },
});